export default __webpack_public_path__ + "static/media/portfolio-bg2.bd1e1c62.jpg";